/* eslint-disable react/jsx-no-undef */
import React, { Component } from "react";
import Grid from "@material-ui/core/Grid/Grid";
import style from "./style";
import Avatar from "@material-ui/core/Avatar/Avatar";
import Hidden from "@material-ui/core/Hidden/Hidden";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import TextField from "@material-ui/core/TextField/TextField";
import * as moment from "moment";
import { parseAmountDecimal } from "../../utils/common-methods";

const DataItem = props => (
  <ListItem divider style={style.listItemStyle}>
    <div>
      <p style={style.label}>{props.label}</p>
    </div>
    <div>
      <p style={style.valueCheck}>{props.value}</p>
    </div>
  </ListItem>
);
class ReviewEngagement extends Component {
  state = {
    message: ""
  };

  componentDidMount() {
    if (!this.props.booking) {
      this.props.push('/chef-bookings?step=1');
    }

    if (this.props.booking) {
      if (this.props.booking.message) {
        this.setState({ message: this.props.booking.message });
      }
    }
  }

  render() {
    const { booking, userDetails } = this.props;
    let dishes = "";
    let maxDiners = booking.dinerSize || 0;
    booking &&
      booking.dishes.length &&
      booking.dishes.map((dish, idx) => {
        dishes += dish.dishName;
        if (idx < booking.dishes.length - 1) {
          dishes += ",";
        }
        maxDiners += dish.serves;
      });
    return (
      <Grid container className="custom-review-container">
        <Grid item md={12} sm={12}>
          <p style={style.headingText}>Review engagement</p>
        </Grid>
        <Hidden smDown>
          <Grid item md={12} sm={12}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className="profile-detail-col">
              <Avatar
                aria-label="Profile Pic"
                style={style.avatar}
                src={
                  userDetails &&
                  userDetails.userProfile &&
                  userDetails.userProfile.profilePic
                }
              />
              <div
                className="engagement-profile-name"
                data-test-id={"revchefname"}
                >
                <p style={{ ...style.userName, ...style.removeMargin }}>
                  {booking ? booking.userName : ''}
                </p>
                {/*<p style={{ ...style.userDistance, ...style.removeMargin }}>
                  {booking ? booking.distance : 0} miles
                </p>*/}
              </div>
            </div>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <p className="price-text" data-test-id={"chefbkgamt"} style={{ ...style.price }}>
                ${booking ? booking.isCustom ? booking.proposalMade ? booking.proposedAmount :
                `${booking.startPrice || 0} - $${booking.endPrice || 0}` :  parseAmountDecimal(booking.amount) : 0}
              </p>
            </div>
          </div>
        </Grid>
        </Hidden>
        <Hidden mdUp>
          <Grid item sm={12}>
            <div style={{ display: "flex" }}>
              <Avatar
                aria-label="Profile Pic"
                style={style.avatar}
                src={
                  userDetails &&
                  userDetails.userProfile &&
                  userDetails.userProfile.profilePic
                }
              />
              <div style={{ marginLeft: "20px", display: 'flex', alignItems: 'center' }}>
                <p style={{ ...style.userNameSM, ...style.removeMargin }}>
                  {booking ? booking.userName : ''}
                </p>
                {/*<p style={{ ...style.userDistance, ...style.removeMargin }}>
                  {booking ? booking.distance : 0} miles
                </p>*/}
              </div>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <p className="price-text" style={{ ...style.priceSM }}>${booking ? booking.amount : 0}</p>
              </div>
            </div>
          </Grid>
        </Hidden>
        <Grid item md={12}>
          <p  data-test-id={"chefdesc"} style={style.description}>
            A foodie is a person who has an ardent or refined interest in food
            and who eats food not out of hunger but due to his interest and
            hobby
          </p>
        </Grid>
        <Grid item md={12}>
          <List>
            <DataItem
              label={"Date"}
              value={moment(new Date(booking.date)).format("DD MMM")}
            />
            <DataItem
              label={"Time"}
              value={`${booking.isCustom ? 'Starts ':''}${moment(
                booking.timeSlot.start,
                "hh:mm a"
              ).format("LT")}${!booking.isCustom ? ' - ' : ''}${!booking.isCustom ? moment(
                booking.timeSlot.end,
                "hh:mm a"
              ).format("LT") : ''}`}
            />
            <DataItem label={'Dishes'} value={booking.isCustom ? 'Custom' : dishes}/>
            <DataItem label={"Number of diners"} value={maxDiners} />
            <ListItem style={style.listItemStyle}>
              <div>
                <p style={style.label}>Message</p>
              </div>
            </ListItem>
            <ListItem style={style.listItemStyle}>
              <TextField
                className="chef-message-column"
                data-test-id={"chefmsg"}
                disabled
                multiline
                rowsMax="4"
                value={booking.message || this.state.message}
                fullWidth
                margin="normal"
                variant="standard"
                onChange={evt => {
                  this.props.onMessageChange(evt.target.value);
                  this.setState({ message: evt.target.value });
                }}
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    );
  }
}

export default ReviewEngagement;
